import { render } from "./ActivityApp.vue?vue&type=template&id=65c58e71&scoped=true"
import script from "./ActivityApp.vue?vue&type=script&lang=js"
export * from "./ActivityApp.vue?vue&type=script&lang=js"

import "./ActivityApp.vue?vue&type=style&index=0&id=65c58e71&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c58e71"]])

export default __exports__